module.exports = __webpack_public_path__ + "static/media/percent.112babdf.svg";